const initialState = {
  types: ['FSK', '450', '450m', 'ePMP', 'PTP', 'Radwin', 'UBNT', 'WIRED'],
  statuses: ['created', 'staging', 'active', 'decommissioned'],
}
export const state = { ...initialState }

export const actions = {
}

export const mutations = {
}
export const getters = {
  apTypes: state => state.types,
  apStatuses: state => state.statuses,
}
export default {
  state,
  actions,
  mutations,
  getters,
}
